import { ItiBaseDto } from '@/iti-core-vue';

export class Reply extends ItiBaseDto {
    public id!: number;
    public content!: string;
    public postId!: number;
    public ambitId!: number;
    public creationDate!: Date;
    public userName!: string;

}
